import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import CheckOkButton from './CheckOkButton';
import CheckNoneButton from './CheckNoneButton';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(
  withState('openLinkedDialog', 'updateOpenLinkedDialog', false),
  withState('openUnlinkedDialog', 'updateOpenUnlinkedDialog', false)
);

const button = enhance(
  ({
    handeOpenSettingUnlimitGochiKidModal,
    checked,
    groupId,
    groupGochiKidUnlimit
  }) => {
    return (
      <div>
        {checked ? (
          <CheckOkButton
            onClickAction={() => {
              handeOpenSettingUnlimitGochiKidModal(true);
            }}
            disabled={groupId && groupGochiKidUnlimit === 1}
          />
        ) : (
          <CheckNoneButton
            onClickAction={() => {
              handeOpenSettingUnlimitGochiKidModal(true);
            }}
          />
        )}
      </div>
    );
  }
);

export default withStyles(styles)(button);
